//
//
//
//
//
//
//

export default {
  name: 'SwitchButton',
  props: ['switchVal', 'editLabel', 'saveLabel'],
  methods: {
    edit() {
      this.$emit('edit');
    },
    save() {
      this.$emit('save');
    },
  },
};
